import styled from 'styled-components';

const Wrapper = styled.div`
  width: 100%;
  padding: 0 2rem;
`;

export default Wrapper;
